import Vue from "vue";
import App from "./App";
import store from './store';
import router from "./router";
import ElementUI from "element-ui";
import infiniteScroll from "vue-infinite-scroll";
import 'element-ui/lib/theme-chalk/index.css'
import "./assets/theme-chalk/new_index.css";
import Edit from './service/modal/dialog.modal'
import 'font-awesome/css/font-awesome.min.css'
import VueAxios from 'vue-axios'
import axiso from './service/http'
import "./index.scss";
import './filter'

Vue.use(ElementUI);
Vue.use(Edit);
Vue.use(infiniteScroll);
Vue.use(VueAxios, axiso)

Vue.directive('drag', {
  bind: function (el) {
    let odiv = el;   //获取当前元素
    let name = el.className;
    odiv.onmousedown = function (e) {
      e = e || window.event;
      if(e.button != 0) return;
      if (e.target.className.indexOf(name) == -1) return;
      //算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;

      document.onmousemove = function (e) {
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        //绑定元素位置到positionX和positionY上面
        this.positionX = top;
        this.positionY = left;

        //移动当前元素
        odiv.style.left = left + 'px';
        odiv.style.top = top + 'px';
      };
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});
export { drag }

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js